import { GetterTree } from 'vuex';
import { ScheduleState, MatchDay, Match } from './models';
import { RootState } from '@/store';

export enum Getters {
  MATCH_DAYS = 'MATCH_DAYS',
  MATCH_DAY = 'MATCH_DAY',
  MATCH = 'MATCH',
  MATCH_DAY_ID_FOR_NEW_MATCH = 'MATCH_DAY_ID_FOR_NEW_MATCH',
  }

export const getters: GetterTree<ScheduleState, RootState> = {
  [Getters.MATCH_DAYS]({ matchDays }): MatchDay[] {
    return matchDays;
  },

  [Getters.MATCH_DAY]({ matchDays }) {
    return (matchDayId: number): MatchDay => {
      return matchDays.filter((md) => md.id === matchDayId)[0];
    };
  },

  [Getters.MATCH]({ matchDays }) {
    return (matchId: number, matchDayId: number): Match | undefined => {
      const matchDay = matchDays.filter((md) => md.id === matchDayId)[0];
      if (matchDay.matches) {
        return matchDay.matches.filter((m) => m.id === matchId)[0];
      }
    };
  },

  [Getters.MATCH_DAY_ID_FOR_NEW_MATCH]({ matchDayIdForNewMatch }): number | undefined {
    return matchDayIdForNewMatch;
  },

};
